import { Message } from 'screens/Messages/Messages.type';

import { CreateConversation, CreateMessage } from '../Conversation/Conversation.types';
import { MessageAttachment } from '../Inputs/Inputs.types';

export interface Props {
  message: Message;
  conversationId: string;
  latestMessage: boolean;
  onSend: (
    argument: CreateConversation | CreateMessage,
    attachment?: MessageAttachment[]
  ) => Promise<any>;
}

export const PRESET_USER_RESPONSES = Object.freeze({
  POSITIVE: 'Yes',
  NEGATIVE: 'No, send the message to the medical team'
});
